import * as Handlebars from 'handlebars/runtime'
module.exports = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"select-controls-wrapper\">\n	<label class=\"field\">\n		<span class=\"label-text\">"
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"datasets.field",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":27},"end":{"line":3,"column":52}}}))
    + "</span>\n		<select name=\"fieldId\"></select>\n	</label>\n</div>\n";
},"useData":true})